// Importing required modules and components from external libraries and files.
import React, { useState, useEffect } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Home from "./components/Home";
import LoanOfficerHome from "./components/LoanOfficerHome";

import axios from "axios";
import "./App.css";

// Main component responsible for setting up routing using "Routes" and "Route" components from "react-router-dom".
export default function App() {
  return (
    <Routes>
      {/* When the path matches "/:loanofficername/*", it will render the "LoanOrRealtorHome" component. */}
      <Route path="/:loanofficername/*" element={<LoanOfficerHome />} />
      {/* When the path matches "/search", it will render the "Home" component. */}
      <Route path="/search" element={<Home />} />
    </Routes>
  );
}

